import React from "react";
import { UiConstants } from "../../data/UiConstants";
import styled from "styled-components";
import { Heading1Base } from "../shared/Heading";
import { AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
export const CustomModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',

    /*
    borderWidth: '2px',
    borderColor: '#0d005e',
    */
    border: 'none',
    maxWidth: "350px"
  },
  overlay: {
    zIndex: UiConstants.Z_INDEX_MODAL
  }
};
export const ModalTitle = styled(Heading1Base).withConfig({
  displayName: "ModalComponents__ModalTitle",
  componentId: "sc-1t8oi2-0"
})(["margin:0px;margin-bottom:8px;"]);
export const ModalButton = styled.button.withConfig({
  displayName: "ModalComponents__ModalButton",
  componentId: "sc-1t8oi2-1"
})(["flex:1;margin:4px;display:flex;justify-content:center;"]);
export const ModalButtonDanger = styled(ModalButton).withConfig({
  displayName: "ModalComponents__ModalButtonDanger",
  componentId: "sc-1t8oi2-2"
})(["color:red;"]);
export const ModalButtonBar = styled.div.withConfig({
  displayName: "ModalComponents__ModalButtonBar",
  componentId: "sc-1t8oi2-3"
})(["display:flex;padding-top:8px;"]);
export const ModalDeleteCloseButtonBar = ({
  confirm,
  closeModal
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ModalButtonBar, null, /*#__PURE__*/React.createElement(ModalButton, {
    onClick: e => {
      e.stopPropagation();
      closeModal();
    }
  }, t("editor.dialog_cancel")), /*#__PURE__*/React.createElement(ModalButtonDanger, {
    onClick: e => {
      e.stopPropagation();
      confirm();
    }
  }, /*#__PURE__*/React.createElement(AiFillDelete, null), t("editor.dialog_confirm")));
};